export const APP_STORE_ID = '1209815023';
export const GOOGLE_PLAY_URL = 'market://details?id=com.cliffweitzman.speechify2';
export const APP_STORE_URL = `https://apps.apple.com/en/app/speechify-text-to-speech/id${APP_STORE_ID}`;
